module.exports = __webpack_public_path__ + "static/media/hourseracing.9cb0008e.svg";